import { PropsWithChildren } from 'react';
import { Field } from '@chakra-ui/react';
import { AnyBlock, BlockType } from '@/lib/types';

export interface BaseInputBlockProps<T = AnyBlock> {
  block: T;
}

export default function BaseInputBlock({
  block,
  children,
}: PropsWithChildren<BaseInputBlockProps>) {
  return (
    <Field.Root>
      {![BlockType.Checkbox, BlockType.SectionTitle].includes(block.field_type) && (
        <Field.Label>{block.field_name}</Field.Label>
      )}
      {children}
    </Field.Root>
  );
}
